/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductionUpdate
 */
export interface ProductionUpdate {
    /**
     * 
     * @type {string}
     * @memberof ProductionUpdate
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionUpdate
     */
    obscureName?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductionUpdate
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionUpdate
     */
    longDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionUpdate
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductionUpdate
     */
    template?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionUpdate
     */
    defaultGroup?: number | null;
}

export function ProductionUpdateFromJSON(json: any): ProductionUpdate {
    return ProductionUpdateFromJSONTyped(json, false);
}

export function ProductionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'obscureName': !exists(json, 'obscure_name') ? undefined : json['obscure_name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'longDescription': !exists(json, 'long_description') ? undefined : json['long_description'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'template': !exists(json, 'template') ? undefined : json['template'],
        'defaultGroup': !exists(json, 'default_group') ? undefined : json['default_group'],
    };
}

export function ProductionUpdateToJSON(value?: ProductionUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'obscure_name': value.obscureName,
        'description': value.description,
        'long_description': value.longDescription,
        'active': value.active,
        'template': value.template,
        'default_group': value.defaultGroup,
    };
}


